import { Component } from '@angular/core';
import { UtilsTableSkeletonComponent } from '../utils-table-skeleton/utils-table-skeleton.component';
import { UtilsActionButtonsSkeletonComponent } from '../utils-action-buttons-skeleton/utils-action-buttons-skeleton.component';

@Component({
  selector: 'app-utils-tabs-skeleton',
  standalone: true,
  templateUrl: './utils-tabs-skeleton.component.html',
  imports: [UtilsTableSkeletonComponent, UtilsActionButtonsSkeletonComponent],
  styleUrl: './utils-tabs-skeleton.component.scss'
})
export class UtilsTabsSkeletonComponent {
  readonly numberOfTabs = new Array(7);
}
